import {
  getBranch,
  getFirstName,
  getKey,
  getLastName,
  getStreetAddress,
  getToken,
  getUser,
  getDefLatitude,
  getDefLongitude,
  getDefAddress,
} from "../Utils/Common"
import {
  getAPICall,
  postAPICall,
  putAPICall,
  deleteAPICall,
  API_KEY,
  TOKEN,
  postAPICall2,
  getAPICallGoogle,
} from "./axiosMethodCalls"

//Add Store API
export const createStore = async (
  data,
  cigarArr,
  isIllicit,
  hasImage,
  isPos1,
  isPos2,
  isFlyer,
  isQR,
  isTradeLetter
) => {
  try {
    var formData = new FormData()
    formData.append("requester", getUser())
    formData.append("token", getToken().replace(/['"]+/g, ""))
    formData.append("store_date", data.store_date)
    formData.append("store_name", data.store_name)
    formData.append("street_name", data.street_name)
    formData.append("barangay", data.barangay)
    formData.append("city", data.city)
    formData.append("remarks", data.remarks)
    formData.append("latitude2", data.latitude)
    formData.append("longitude2", data.longitude)
    formData.append("address2", getStreetAddress())
    formData.append("agent_visit", data.agent_visit)
    formData.append("poster_priority_1", data.poster_priority_1)
    formData.append("poster_priority_2", data.poster_priority_2)
    formData.append("flyer", data.flyer)
    formData.append("is_poster_priority_1", isPos1 === "YES" ? 1 : 0)
    formData.append("is_poster_priority_2", isPos2 === "YES" ? 1 : 0)
    formData.append("is_flyer", isFlyer === "YES" ? 1 : 0)
    formData.append("trade_letter", data.trade_letter)
    formData.append("address1", getDefAddress())
    formData.append("latitude1", getDefLatitude())
    formData.append("longitude1", getDefLongitude())
    formData.append("selling_illicit_cigar", isIllicit === "YES" ? 1 : 0)
    formData.append("qr_code", isQR === "YES" ? 1 : 0)
    if (hasImage === "YES") {
      formData.append("store_image", data.store_image[0])
    }
    if (hasImage === "NO") {
      formData.append("reason_image", data.reason_image)
    }
    cigarArr.map((data) => {
      formData.append("brand_names[]", data.brand_name)
      formData.append("pack_prices[]", data.pack_price)
      formData.append("stick_prices[]", data.stick_price)
      formData.append("weekly_sales[]", data.weekly_sale)
    })

    const response = await postAPICall2(
      process.env.REACT_APP_PROCAST_LINK + "store_locations/add",
      formData
    )
    return { data: response.data }
  } catch (error) {
    console.error(error)
    return { error: error.response }
  }
}

export const createTimesheet = async (data) => {
  try {
    var formData = new FormData()
    formData.append("requester", getUser())
    formData.append("token", getToken().replace(/['"]+/g, ""))
    formData.append("address", data.address_1 || "")
    formData.append("address2", data.address || "")
    formData.append("latitude", data.latitude)
    formData.append("longitude", data.longitude)
    formData.append("photo_proof", data.photo_proof[0])
    const response = await postAPICall2(
      process.env.REACT_APP_PROCAST_LINK + "timesheets/time_in",
      formData
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const createTimesheetOut = async (timesheet_id) => {
  try {
    var formData = new FormData()
    formData.append("requester", getUser())
    formData.append("token", getToken().replace(/['"]+/g, ""))
    formData.append("timesheet_id", timesheet_id)
    const response = await postAPICall2(
      process.env.REACT_APP_PROCAST_LINK + "timesheets/time_out",
      formData
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const searchTimesheet = async () => {
  try {
    var formData = new FormData()
    formData.append("requester", getUser())
    formData.append("token", getToken().replace(/['"]+/g, ""))
    //   formData.append("timesheet_id",timesheet_id)
    const response = await postAPICall2(
      process.env.REACT_APP_PROCAST_LINK + "timesheets/search",
      {
        requester: getUser(),
        token: getToken().replace(/['"]+/g, ""),
        date_from: new Date().toLocaleDateString("en-US"),
        date_to: new Date().toLocaleDateString("en-US"),
        // date_from: "12/12/2022",
        // date_to: "12/12/2022",
        type: "agent",
        agent_id: getUser(),
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

//Get Store API
export const getStores = async (store_id, lat, lng) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_PROCAST_LINK + "store_locations/search",
      {
        requester: getUser(),
        requester_only: true,
        token: getToken().replace(/['"]+/g, ""),
        // store_location_id: store_id,
        latitude: lat,
        longitude: lng,
      }
    )
    return { data: response.data.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const getLocationOnLoad = async (lat, lng) => {
  try {
    const response = await getAPICallGoogle(
      "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
        lat +
        "," +
        lng +
        "&key=AIzaSyAHeix3Mf1YRppXp1hxArkPwkevOZFc1Ew"
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const getStoresToday = async () => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_PROCAST_LINK + "store_locations/search",
      {
        requester: getUser(),
        requester_only: true,
        // encoded_by:getUser(),
        token: getToken().replace(/['"]+/g, ""),
        date_from: new Date().toLocaleDateString("en-US"),
        date_to: new Date().toLocaleDateString("en-US"),
      }
    )
    return { data: response.data.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const syncStores = async (payload) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_PROCAST_LINK + "store_locations/sync",
      {
        requester: getUser(),
        token: getToken().replace(/['"]+/g, ""),
        store_upload: payload,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}
